import * as t from 'io-ts';

export const FrequencyLimitV = t.union([
  t.literal('no_limit'),
  t.literal('once_per_session'),
  t.literal('once_per_user'),
  t.literal('until_interaction'),
]);
